(function ($) {
  var $newsletterForm = $('#newsletterForm');

  var handleError = function() {
    $newsletterForm
        .find('.alert-danger')
        .removeClass('d-none')
  }
  var handleSuccess = function () {
    $newsletterForm
        .find('input[name="email"]')
        .attr('disabled', true)
        .addClass('d-none');
    $newsletterForm
        .find('[type="submit"]')
        .addClass('d-none');
    $newsletterForm
        .find('.alert-success')
        .removeClass('d-none')
  }

  $newsletterForm.on('submit', function (e) {
    e.preventDefault();
    var $emailField = $newsletterForm.find('input[name="email"]');

    fetch(e.currentTarget.action, {
      method: 'POST',
      json: true,
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        list: 'newsletter',
        email: $emailField.val(),
      })
    })
    .then(function (response) {
      if (response.ok) {
        handleSuccess();
      } else {
        handleError();
      }
    });
  });
})(window.jQuery);
